// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1mJO8","actionsCol":"EnrolledClinics_actionsCol__3D8MK"};